/* Bundle templates: strike price from the Fly Bundles widget.
   The EUR markets get no compare-at price from Shopify. The widget sums up the single prices of the bundle's
   products in the visitor's currency, so its "original" total fills the empty strike price next to the price.
   Without the widget, or for a bundle without a saving, the label stays hidden. */
(function () {
  var bundleCompare = document.querySelector('[data-drop-bundle-compare]');
  var bundleCompareLabel = document.querySelector('[data-drop-bundle-compare-label]');
  // Shopify delivered a compare-at price: the label is already visible, nothing to fill in.
  if (!bundleCompare || !bundleCompareLabel || !bundleCompareLabel.hidden) return;

  // Amount in minor units, independent of currency symbol and separators.
  var amount = function (text) { return parseInt(text.replace(/\D/g, ''), 10) || 0; };

  var fillCompare = function () {
    var source = document.querySelector(
      '.gfbFrequentBoughtWidgetOfferContainerBundleRegular .gfbFrequentBoughtWidgetPriceContainerPriceOriginal'
    );
    var value = source ? source.textContent.trim() : '';
    if (!value) return false;
    var price = document.querySelector('.limited-drop-price .price__main');
    // No saving against the single prices: nothing to compare against.
    if (price && amount(value) <= amount(price.textContent)) return true;
    bundleCompare.textContent = value;
    bundleCompareLabel.hidden = false;
    return true;
  };

  if (!fillCompare() && 'MutationObserver' in window) {
    var mo = new MutationObserver(function () { if (fillCompare()) mo.disconnect(); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }
})();
